import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router-dom';
import { useParams } from 'react-router';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import ClassworkTopic from './ClassworkTopic/ClassworkTopic';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { StateContext, DispatchContext } from '../../../context/Provider';

import TopicModal from './Modals/TopicModal';
import ClassworkModal from './Modals/ClassworkModal';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles((theme) => ({
    inlineButtons: {
        '& > *': {
            margin: theme.spacing(0.3),
        },
    },
}));

const NoTopicsFound = () => {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={10}>
            <Paper>
                <Box px={2} py={5}>
                    <Typography variant="body2" color="textSecondary" component="p" align="center">
                        No topic/s found.
                    </Typography>
                </Box>
            </Paper>
        </Grid>
    );
}

const Classwork = (props) => {

    const classes = useStyles();
    const { classcode } = useParams();
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [topicModalOpen, setTopicModalOpen] = useState(false);
    const [classworkModalOpen, setClassworkModalOpen] = useState(false);

    const [topics, setTopics] = useState([]);

    const handleTopicModalOpen = () => {
        setTopicModalOpen(true);
    }

    const handleTopicModalClose = () => {
        setTopicModalOpen(false);
    }

    const handleClassworkModalOpen = () => {
        setClassworkModalOpen(true);
    }

    const handleClassworkModalClose = () => {
        setClassworkModalOpen(false);
    }

    const [showActiveClassworks, setShowActiveClassworks] = useState(true);
    async function fetchTopics() {

        try {
            const response = await axiosConfig.get(`/topics?classcode=${classcode}&activeOnly=${showActiveClassworks}`);
            const { data } = response.data;

            setTopics(data);

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {
        globalDispatch({type: 'setIsLoading', value: true});
        fetchTopics()
    }, [showActiveClassworks])

    useEffect(() => {

        if (!classcode) {
            <Redirect to="/dashboard" />;
        }

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setTabValue', value: 1});
        globalDispatch({type: 'setShowTabs', value: true});

        const source = axiosConfig.CancelToken.source();
        fetchTopics();
        return () => {
            source.cancel();
        }

    }, []);

    const ActionBtn = () => (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={10}>
            <div className={classes.inlineButtons}>
                <Button
                    disableRipple
                    color="primary"
                    variant="outlined"
                    size="medium"
                    startIcon={<CreateOutlinedIcon />}
                    onClick={handleTopicModalOpen}
                >
                    Create Topic
                </Button>
                <Button
                    disableRipple
                    color="secondary"
                    variant="outlined"
                    size="medium"
                    startIcon={<CreateOutlinedIcon />}
                    onClick={handleClassworkModalOpen}
                >
                    Create Classwork
                </Button>
                { authState.user.role_id === 4 &&
                    <Button
                        disableRipple
                        color="secondary"
                        variant="outlined"
                        size="medium"
                        startIcon={<VisibilityIcon />}
                        onClick={() => {
                            setShowActiveClassworks(current => !current);
                        }}
                    >
                        { showActiveClassworks ? 'View Lessons Archive' : 'View Active Lessons' }
                    </Button>
                }
            </div>

            <Box mb={2} />
        </Grid>
    );

    return (
        <ResponsiveLayout classcode={classcode}>
            <Box mt={2} />
            <Grid
                container
                spacing={2}
                justify="center"
            >

                { topicModalOpen ? (
                    <TopicModal
                        open={topicModalOpen}
                        handleClose={handleTopicModalClose}
                        dialogTitle={`Create Topic`}
                        classcode={classcode}
                        topicID={null}
                        fetchTopics={fetchTopics}
                    />
                    ) : null
                }

                { classworkModalOpen ? (
                    <ClassworkModal
                        open={classworkModalOpen}
                        handleClose={handleClassworkModalClose}
                        dialogTitle={`Create Classwork`}
                        classcode={classcode}
                        classworkID={null}
                        fetchTopics={fetchTopics}
                    />
                    ) : null
                }

                { authState.user.role_id === 4 ? (<ActionBtn />) : null }

                { topics.length === 0 ? <NoTopicsFound /> : null }

                {topics.map((topic, i) => (
                    <ClassworkTopic
                        key={topic.id}
                        classcode={classcode}
                        topicID={topic.id}
                        topic={topic}
                        fetchTopics={fetchTopics}
                        showActiveClassworks={showActiveClassworks}
                    />
                ))}
            </Grid>
        </ResponsiveLayout>
    );
}

export default Classwork;